module.exports = __webpack_public_path__ + "img/po-article2-bg.e8663702.png";